<template>
  <div style="display:flex">
    <input
      :key="props.id + ' '"
      :id="props.field"
      :data-cy="props.id.split('_')[1] + '-' + props.field"
      v-bind="$attrs"
      ref="inputField"
      v-model="value"
      role="CalcInput"
      class="calc-input"
      hide-details
      :readonly="readonly"
      :class="{ occupied: isOccupied, readonly: readonly }"
      @focus="watchFocus(true)"
      @blur="watchFocus(false)"
      @keydown="isNumber"
      @wheel="() => inputField?.blur()">

    </input>

    <v-avatar
      size="20"
      v-if="isOccupied"
      color="primary"
      style="position: fixed; right: 10px; top: 10px; font-size: 12px">
          {{ mainStore.getInitials(isOccupied) }}
    </v-avatar>
    <math-tooltip v-if="authStore.isSuperUser" :name="props.field" :title="$t(`entities.${elementType}.fields.${field}`)"/>

  </div>
</template>

<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import { computed, toRef } from "vue";
import { useMainStore } from "@/stores/mainStore";
import { useCalcInput } from "./calcInputComposable";
import { useAuthStore } from "@/stores/authStore";
import MathTooltip from "./MathTooltip.vue";

const copyName = () => {
  navigator.clipboard.writeText(`,"${props.field}"`);
};

const authStore = useAuthStore();
const mainStore = useMainStore();

const props = withDefaults(defineProps<{
  id: string;
  field: string;
  type: "text" | "number";
  readonly: boolean;
  icon: string | null;
}>(), {
  type: "text"
});

const [_, elementType] = props.id.split("_");


const { inputField, isOccupied, watchFocus, value, isNumber, readonly } = useCalcInput(
  toRef(() => props.id),
  toRef(() => props.field),
  props.readonly,
  props.type
);
</script>
<style scoped lang="scss">
.calc-input {
  /* Add your styles here */
  border: 1px solid #ccc;
  padding: 0px 5px 3px 8px;
  border-radius: 4px;
  width: 100%;
}

.error {
  border-color: red;
}

.occupied {
  /* background-color: #f0f0f0; */
  opacity: 0.3;
  pointer-events: none;
}
.readonly {
  /* background-color: #f0f0f0; */
  opacity: 0.8;
  pointer-events: none;
}
</style>
